var Modernizr = require('modernizr');
var queryString = require('query-string');
var pagination = require('imports-loader?jQuery=jquery!../../js/libraries/jquery.simplePagination.js');
var smoothScroll = require('smoothscroll');
var ProductGrid = require('../ProductGrid.js');

var exports = (module.exports = {});

var s;
var SupplierPage = {
  settings: {},

  init: function() {
    var that = this;
    s = this.settings;
    // this.bindUIelement();
    var currentPage = parseInt(queryString.parse(location.search).page * 1);
    if (window.totalElements) {
      that.initPagination(currentPage);
    }

    if (!$('.products-grid').hasClass('initialised')) {
      ProductGrid.init('.products-grid');
    }
  },

  // toggleParameter: function (filterGroup, filterName, needUrl) {

  //     var that = this;
  //     var queryObject = queryString.parse(location.search);

  //     if (queryObject[filterGroup]) {

  //         if (typeof queryObject[filterGroup] === 'object') {
  //             if (queryObject[filterGroup].indexOf(filterName) > -1) {
  //                 // isActive = true;
  //                 var index = queryObject[filterGroup].indexOf(filterName);
  //                 if (index > -1) {
  //                     queryObject[filterGroup].splice(index, 1);
  //                 }
  //             } else {
  //                 queryObject[filterGroup].push(filterName);
  //             }
  //         } else {
  //             if (queryObject[filterGroup] == filterName) {
  //                 //if filter exists

  //                 delete queryObject[filterGroup]
  //             } else {
  //                 //if filter does not exist, add it to the others
  //                 if (filterGroup != 'location') {
  //                     console.log('stop');
  //                     var arr = [];
  //                     arr.push(queryObject[filterGroup]);
  //                     arr.push(filterName);
  //                     queryObject[filterGroup] = arr;
  //                 } else { // or replace the current one for 'location'
  //                     queryObject[filterGroup] = filterName;
  //                 }

  //             }
  //         }

  //     } else {

  //         queryObject[filterGroup] = filterName;

  //     }

  //     queryObject["page"] = 0;

  //     //return or not
  //     this.updateUrl(queryObject);

  // },

  updateUrl: function(pageNumber) {
    var that = this;
    //update URL
    // console.log(queryString.stringify(param));
    var newUrlQuery = queryString.parse(location.search);
    newUrlQuery.page = pageNumber;

    console.log(newUrlQuery);
    if (history.pushState) {
      window.history.pushState(null, null, '?' + queryString.stringify(newUrlQuery));
    } else {
      document.location.href = '?' + queryString.stringify(newUrlQuery);
    }

    // that.addCategory();
  },

  // bindUIelement: function () {

  //     var that = this;

  //     s.filterCheckbox.on('click', function (e) {

  //         e.preventDefault();

  //         $(".right-container-wrapper").css("opacity", ".3");
  //         $(".right-container-wrapper").css("pointer-events", "none");
  //         var filterGroup = $(e.currentTarget).attr('group').toLowerCase();
  //         var filterValue = $(e.currentTarget).attr('value').toLowerCase();
  //         var url = $(e.currentTarget).attr("href");

  //         if ($(e.currentTarget).hasClass('filter-checkbox--active')) {
  //             that.toggleParameter(filterGroup, filterValue, true);
  //         } else {
  //             that.toggleParameter(filterGroup, filterValue, true);
  //         }
  //     });

  //     $(document).on("click", s.dom_removeFilterButton, function (e) {

  //         e.preventDefault();
  //         console.log(e.currentTarget);
  //         var filterGroup = $(e.currentTarget).attr('data-group').toLowerCase();
  //         var filterValue = $(e.currentTarget).attr('data-id').toLowerCase();

  //         // var url = $(e.currentTarget).attr('href');
  //         that.toggleParameter(filterGroup, filterValue, true);
  //     });

  //     if ($(s.mobileSidebarTrigger).length) {
  //         $(s.mobileSidebarTrigger).on('click', function () {
  //             $(s.mobileSidebarFilterWrapper).toggleClass('opened');
  //             $('body').toggleClass('modal-open');
  //         })

  //         $('.btn-filter-sidebar-done').on('click', function () {
  //             $(s.mobileSidebarFilterWrapper).toggleClass('opened');
  //             $('body').toggleClass('modal-open');
  //         })
  //     }
  //     return false;
  // },

  // replaceProducts: function (urlQuery) {

  //     var that = this;

  //     $.ajax({
  //         url: '/search/products?' + urlQuery,
  //         data: {
  //             ajax: 'true'
  //         },
  //         error: function () {
  //             console.log('error');
  //         },
  //         success: function (data) {
  //             $('#search-products-grid-items').html(data);
  //             that.updateFilterSidebar();
  //             that.initPagination();

  //         },
  //         type: 'GET'
  //     });

  // },

  // updateFilterSidebar: function () {
  //     var that = this;
  //     var activeCatArray = queryString.parse(location.search);
  //     console.log(activeCatArray);
  //     this.resetFilters();
  //     $.each(activeCatArray, function (k, value) {

  //         if ($.isArray(value)) {
  //             for (var item in value) {
  //                 // console.log(k + " : " + valueArray[item])
  //                 $(".filter-checkbox[group=" + encodeURI(k) + "][value='" + encodeURI(value[item]) + "']").toggleClass('filter-checkbox--active');
  //             }
  //         } else {
  //             $(".filter-checkbox[group=" + encodeURI(k) + "][value='" + encodeURI(value) + "']").toggleClass('filter-checkbox--active');
  //         }

  //     });

  // },

  initPagination: function(pagenumber) {
    var that = this;
    pagenumber = pagenumber ? pagenumber : parseInt(queryString.parse(location.search).page);
    $('.pagination-products-supplier').pagination({
      items: window.totalElements,
      itemsOnPage: 20,
      currentPage: pagenumber ? pagenumber : 1,
      cssStyle: 'light-theme',
      hrefTextPrefix: '?page=',
      selectOnClick: false,
      nextText: '<i class="fa-right-open-big"></i>',
      prevText: '<i class="fa-left-open-big"></i>',
      onPageClick: function(pageNumberOnClick, event) {
        $('#product-grid > *').css('opacity', '0.3');

        event.preventDefault();
        $.ajax({
          url: window.location.origin + window.location.pathname,
          data: {
            ajax: true,
            page: pageNumberOnClick
          }
        }).done(function(data) {
          $('#product-grid').html(data);
          that.updateUrl(pageNumberOnClick);
          that.init();
          that.scrollToProductsPage();
        });
      }
    });
  },

  scrollToProductsPage: function() {
    var productsGrid = document.querySelector('#product-grid');

    smoothScroll(productsGrid);
  }
};

module.exports = SupplierPage;



// WEBPACK FOOTER //
// ./public/src/js/pages/supplierPage.js